// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styleAvatar[data-v-a1daa526]{margin-left:-55px;position:relative}", "",{"version":3,"sources":["webpack://./resources/js/components/VLink.vue"],"names":[],"mappings":"AACA,8BAEI,iBAAA,CADA,iBACJ","sourcesContent":["\n.styleAvatar {\n    position: relative;\n    margin-left: -55px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
